import { Box, Button, Link, Stack, Typography } from "@mui/material"

interface TopBarProps {
  phone: boolean
}

export default function TopBar({ phone }: TopBarProps) {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        pt: 4,
        pb: 4,
        background: "rgba(7, 16, 33, 0.6)",
      }}
      width="100%"
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        maxWidth="1100px"
        sx={{ pr: 2 }}
      >
        <Box
          component="img"
          src="/logo100x50.png"
          sx={{ ml: 3 }}
          width={phone ? 120 : 150}
        />
        <Stack alignItems={"center"} spacing={1} sx={{ mt: 1 }}>
          <Button
            variant="contained"
            sx={{
              mr: 3,
              background: "rgb(79, 150, 13)",
              color: "white",
              fontWeight: "bold",
            }}
            onClick={() =>
              window.open(
                "https://calendar.app.google/9dcR6mKhQMhb8UoU9",
                "_blank"
              )
            }
          >
            Demander une démo
          </Button>
          <Link
            href="mailto:victor@wm-up.com"
            style={{ textDecoration: "none" }}
          >
            <Typography>Contactez-nous</Typography>
          </Link>
        </Stack>
      </Stack>
    </Stack>
  )
}
